module.exports = __webpack_public_path__ + "static/media/pousada_8.f048798c.jpg";